/**
 * Kite pages enhancement
 * - Filters the Color swatches to only the colors available for the selected Size
 * - Shows live quantity available for the selected Size + Color combination
 *   (format: "1 item left" / "2 items left", blank when unavailable)
 * - Adds the optional "Bar Control System" add-on to the cart alongside the kite
 *
 * Scoped to product.type == "Kite" only (see data-product-type on .product-section).
 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function getSelectedValue(wrap) {
    var checked = wrap.querySelector('[data-variant-input]:checked');
    return checked ? checked.value : null;
  }

  function initKiteVariantFilter(root) {
    var variantJsonEl = root.querySelector('[data-variant-json]');
    if (!variantJsonEl) return;

    var variants;
    try {
      variants = JSON.parse(variantJsonEl.textContent);
    } catch (e) {
      return;
    }

    var wraps = root.querySelectorAll('.variant-input-wrap[data-index]');
    if (!wraps.length) return;

    var sizeWrap = null;
    var colorWrap = null;
    wraps.forEach(function (w) {
      var handle = (w.getAttribute('data-handle') || '').toLowerCase();
      if (!sizeWrap && (handle.indexOf('size') !== -1 || handle.indexOf('tama') !== -1)) {
        sizeWrap = w;
      } else if (!colorWrap && (handle.indexOf('color') !== -1 || handle.indexOf('colour') !== -1)) {
        colorWrap = w;
      }
    });

    // Nothing to cross-filter if this product doesn't have both a size and a color option
    if (!sizeWrap || !colorWrap) return;

    var sizeIndex = sizeWrap.getAttribute('data-index'); // e.g. "option1"
    var colorIndex = colorWrap.getAttribute('data-index'); // e.g. "option2"

    function variantsForSize(size) {
      return variants.filter(function (v) {
        return v[sizeIndex] === size;
      });
    }

    function findVariant(size, color) {
      var matches = variants.filter(function (v) {
        return v[sizeIndex] === size && v[colorIndex] === color;
      });
      return matches[0] || null;
    }

    function ensureNoteEl() {
      var note = root.querySelector('[data-kite-stock-note]');
      if (!note) {
        note = document.createElement('p');
        note.setAttribute('data-kite-stock-note', '');
        note.style.fontSize = '13px';
        note.style.marginTop = '6px';
        colorWrap.parentNode.insertBefore(note, colorWrap.nextSibling);
      }
      return note;
    }

    function updateQuantityNote(variant) {
      var note = ensureNoteEl();

      if (!variant || variant.inventory_management !== 'shopify') {
        note.textContent = '';
        return;
      }

      if (variant.inventory_quantity > 0) {
        var qty = variant.inventory_quantity;
        note.textContent = qty + (qty === 1 ? ' item left' : ' items left');
      } else {
        note.textContent = '';
      }
    }

    function refreshColorsForSize(size, opts) {
      opts = opts || {};
      var availableColors = {};
      variantsForSize(size)
        .filter(function (v) {
          return v.available;
        })
        .forEach(function (v) {
          availableColors[v[colorIndex]] = true;
        });

      var inputs = colorWrap.querySelectorAll('[data-variant-input]');
      var selectedInput = colorWrap.querySelector('[data-variant-input]:checked');
      var selectedStillValid = selectedInput && availableColors[selectedInput.value];

      inputs.forEach(function (input) {
        var isAvailable = !!availableColors[input.value];
        var wrapperDiv = input.closest('.variant-input');
        var label = wrapperDiv ? wrapperDiv.querySelector('label') : null;

        if (isAvailable) {
          input.classList.remove('disabled');
          input.disabled = false;
          if (label) label.classList.remove('disabled');
          if (wrapperDiv) wrapperDiv.style.display = '';
        } else {
          input.classList.add('disabled');
          if (label) label.classList.add('disabled');
          if (wrapperDiv) wrapperDiv.style.display = 'none';
        }
      });

      if (!selectedStillValid && !opts.skipAutoSelect) {
        var firstAvailableInput = colorWrap.querySelector('[data-variant-input]:not(.disabled)');
        if (firstAvailableInput) {
          firstAvailableInput.checked = true;
          firstAvailableInput.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          updateQuantityNote(null);
        }
      } else {
        var currentColor = getSelectedValue(colorWrap);
        updateQuantityNote(findVariant(size, currentColor));
      }
    }

    sizeWrap.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('[data-variant-input]')) return;
      refreshColorsForSize(e.target.value);
    });

    colorWrap.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('[data-variant-input]')) return;
      var size = getSelectedValue(sizeWrap);
      updateQuantityNote(findVariant(size, e.target.value));
    });

    var initialSize = getSelectedValue(sizeWrap);
    if (initialSize) {
      refreshColorsForSize(initialSize, { skipAutoSelect: true });
      var initialColor = getSelectedValue(colorWrap);
      updateQuantityNote(findVariant(initialSize, initialColor));
    }
  }

  function initBarAddon(root) {
    var select = root.querySelector('[data-bar-addon-select]');
    if (!select) return;
    var form = root.querySelector('form.product-single__form');
    if (!form) return;

    form.addEventListener('submit', function () {
      var variantId = select.value;
      if (!variantId) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
        keepalive: true
      })
        .then(function (res) {
          if (res.ok) {
            select.value = '';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
        })
        .catch(function () {
          /* fail silently - the kite itself still gets added normally */
        });
    });
  }

  function init() {
    document.querySelectorAll('.product-section[data-product-type="Kite"]').forEach(function (root) {
      initKiteVariantFilter(root);
      initBarAddon(root);
    });
  }

  ready(init);
  // Re-init when a section reloads inside the theme editor
  document.addEventListener('shopify:section:load', init);
})();
